/* eslint-disable class-methods-use-this */
/* eslint-disable quote-props */
/* eslint-disable no-param-reassign */

export default class Storage {
  static install(Vue, options) {
    Vue.mixin({
      created() {
        Vue.prototype.$storage = new Storage();
      },
    });
  }

  write = function Write(Key, Data) {
    localStorage.setItem(Key, JSON.stringify(Data));
  };

  read = function Write(Key) {
    const jsonData = localStorage.getItem(Key);
    const Data = JSON.parse(jsonData);
    return Data;
  };
}
